import { Injectable } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { QrCodeService } from './qr-code.service';
import { ScenarioImageService } from '../scenario-image/scenario-image.service';
import { DoorService } from '../door/door.service';
import {UserStorageService} from "../user/user.storage.service";
import {ProductsMap} from "../door/door.service.impl";
import {MainComponent} from "../../main.component";

@Injectable({providedIn: 'root'})
export class QrCodeServiceImpl extends QrCodeService {

  constructor(private readonly scenarioImageService: ScenarioImageService,
              private readonly doorService: DoorService,
              private readonly userStorageService: UserStorageService) {
    super()
  }

  getQrCodeLink(): Observable<string> {

    return combineLatest([this.scenarioImageService.getSelected$(), this.doorService.getSelected$()]).pipe(
      map(([scenario, doorMap]) => {
        const doorsPart = this.buildUrlParametersForDoors(doorMap);

        // Ensure scenario and doorMap are valid
        if (!scenario || !scenario.type || !scenario.shortId) {
          console.error('Invalid scenario data');
          return '';
        }

        return `${location.origin}/?s=${scenario.type}_${scenario.shortId}&u=${this.userStorageService.getUserId()}&${doorsPart}`;
      })
    )
  }

  private buildUrlParametersForDoors(doorMap: ProductsMap): string {
    // Use Object.entries to loop through the key-value pairs in the doorMap
    const paramStrings = Object.entries(MainComponent.getUrlParamsFromProducts(doorMap)).map(([key, value]) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })

    // Join the key-value pairs into a single query string
    const result = paramStrings.join('&');
    return result;
  }

}
